import { type Reducer } from '@reduxjs/toolkit'
import { produce } from 'immer'
import { type ActionType, getType } from 'typesafe-actions'
import { toast } from 'sonner'
import message from '@/common/message/message'
import { ServiceErrorHandler } from '@/connect-types/backend/service'
import {
  type OrganisationServerType,
  type OrganisationType,
  type OrganisationUserType,
} from '@/connect-types/organisations/organisations.type'
import { type User } from '@/connect-types/user/user.type'
import { relDiff } from '@/utils/common'
import { type AccessVenueType } from './access.types'
import { type RollerVenuesType } from '@/pages/[org_id]/marketplace/apps/roller/roller.types'
import {
  type OrganisationRegistrationType,
  type OrganisationTransactionTotalType,
} from '../insight/insight.type'
import * as actions from './organisations.actions'
import { type LinkGeneratorType } from './organisations.types'

interface OrganisationByType {
  reseller: OrganisationType[]
  default: OrganisationType[]
  root: OrganisationType[]
}
export type OrgRegKeys = keyof OrganisationRegistrationType
export type OrgTransactionKeys = keyof OrganisationTransactionTotalType
export interface StateType {
  selectedUser?: User | null
  /**
   *
   */

  organisationsByType: OrganisationByType
  canQuote: boolean
  loading: boolean

  serverOrganisations: OrganisationServerType[]
  serverOrganisationAccess: OrganisationUserType[]
  integrations: {
    hooks: {
      isLoading: boolean
      links: LinkGeneratorType[]
    }
    access: {
      venues: AccessVenueType[]
      isLoading: boolean
    }
    roller: {
      venues: Record<string, RollerVenuesType>
      isLoading: boolean
    }
  }
}

export const initialState: StateType = {
  integrations: {
    hooks: {
      isLoading: false,
      links: [],
    },
    access: {
      venues: [],
      isLoading: false,
    },
    roller: {
      venues: {},
      isLoading: false,
    },
  },
  selectedUser: null,

  organisationsByType: {
    reseller: [],
    default: [],
    root: [],
  },
  canQuote: false,
  loading: false,

  serverOrganisations: [],
  serverOrganisationAccess: [],
}

export type OrganisationsAction = ActionType<typeof actions>

export const orgNameToSlug = (name: string) => {
  if (!name) return null
  return name.toLowerCase().replace(' ', '-')
}

const organisationsReducer: Reducer<StateType, OrganisationsAction> = (
  state = initialState,
  action
) =>
  produce<StateType>(state, (draft: any) => {
    switch (action.type) {
      /*
      case getType(actions.organisationPutUsersRequest): {
        draft.loading = true
        draft.userAdded = false
        break
      }
      case getType(actions.organisationPutUsersRequestSuccess): {
        draft.loading = false
        const findIndex = draft.users.findIndex(
          (user: any) => user.uid === action.payload.response.uid
        )

        if (findIndex >= 0) {
          draft.users[findIndex] = action.payload.response
        } else {
          draft.users.push(action.payload.response)
        }

        toast.success('User added')
        draft.needsToCreateUser = false
        draft.userAdded = true
        break
      }
      case getType(actions.organisationPutUsersRequestFailure): {
        draft.loading = false
        if (isAxiosError(action.payload.error)) {
          console.log(action.payload.error.response.status, 'status-here')
          if (action.payload.error.response.status === 404) {
            draft.needsToCreateUser = true
          }
        }

        break
      }
      */

      /*
      case getType(actions.organisationDeleteUsersRequest): {
        draft.loading = true
        break
      }
      
      case getType(actions.organisationDeleteUsersRequestSuccess): {
        draft.loading = false
        const index = draft.users.findIndex(
          (member: any) => member.uid === action.payload.uid
        )

        draft.users.splice(index, 1)
        toast.success('User removed')

        break
      }
      case getType(actions.organisationDeleteUsersRequestFailure): {
        draft.loading = false
        break
      }
*/

      case getType(actions.organisationPushNewCustomer): {
        draft.serverOrganisations = [
          ...draft.serverOrganisations,
          action.payload.customer,
        ]

        break
      }

      case getType(actions.getOrganisationLinks.request): {
        draft.integrations.hooks.isLoading = true

        break
      }

      case getType(actions.getOrganisationLinks.success): {
        draft.integrations.hooks.isLoading = false
        draft.integrations.hooks.links = action.payload

        break
      }
      case getType(actions.getOrganisationLinks.failure): {
        draft.integrations.hooks.isLoading = false
        ServiceErrorHandler(action.payload)
        break
      }
      case getType(actions.createOrganisationLinks.request): {
        draft.integrations.hooks.isLoading = true

        break
      }

      case getType(actions.createOrganisationLinks.success): {
        draft.integrations.hooks.isLoading = false
        draft.integrations.hooks.links.push(action.payload)
        toast.success('Link created')
        break
      }
      case getType(actions.createOrganisationLinks.failure): {
        draft.integrations.hooks.isLoading = false
        ServiceErrorHandler(action.payload)
        break
      }

      case getType(actions.getAccessBookingsVenues.request): {
        draft.integrations.access.isLoading = true

        break
      }

      case getType(actions.getAccessBookingsVenues.success): {
        draft.integrations.access.isLoading = false
        draft.integrations.access.venues = action.payload

        break
      }
      case getType(actions.getAccessBookingsVenues.failure): {
        draft.integrations.access.isLoading = false

        break
      }
      /*
      case getType(actions.getTransactionReport.request): {
        draft.reports.isLoading = true

        break
      }

      case getType(actions.getTransactionReport.success): {
        draft.reports.transactions.now = action.payload.now
        draft.reports.transactions.previous = action.payload.previous
        draft.reports.transactions.difference = {
          customers: diffTransCalc(draft.reports.transactions, 'customers'),
          transactions: diffTransCalc(
            draft.reports.transactions,
            'transactions'
          ),
          repeat_customers: diffTransCalc(
            draft.reports.transactions,
            'repeat_customers'
          ),
          avg: {
            value: relDiff(
              draft.reports.transactions.now.avg.cash.customers.penny_price,
              draft.reports.transactions.previous.avg.cash.customers.penny_price
            ),
            positive:
              draft.reports.transactions.now.avg.cash.customers.penny_price >
              draft.reports.transactions.previous.avg.cash.customers
                .penny_price,
          },
          total: {
            value: relDiff(
              draft.reports.transactions.now.total.penny_price,
              draft.reports.transactions.previous.total.penny_price
            ),
            positive:
              draft.reports.transactions.now.total.penny_price >
              draft.reports.transactions.previous.total.penny_price,
          },
        }
        draft.reports.isLoading = false

        break
      }
      case getType(actions.getTransactionReport.failure): {
        draft.reports.isLoading = false
        ServiceErrorHandler(action.payload)
        break
      }
      */

      /**
       * GET ROLLER DATA
       */
      case getType(actions.getRollerData.request): {
        draft.integrations.roller.isLoading = true

        break
      }
      case getType(actions.getRollerData.success): {
        draft.integrations.roller.venues = action.payload
        draft.integrations.roller.isLoading = false
        break
      }
      case getType(actions.getRollerData.failure): {
        draft.integrations.roller.venues = {}
        draft.integrations.roller.isLoading = false
        break
      }

      case getType(actions.postRollerData.request): {
        draft.integrations.roller.isLoading = true

        break
      }
      case getType(actions.postRollerData.success): {
        draft.integrations.roller.venues = action.payload
        draft.integrations.roller.isLoading = false
        toast.success('Roller venue saved')
        break
      }
      case getType(actions.postRollerData.failure): {
        draft.integrations.roller.venues = {}
        draft.integrations.roller.isLoading = false
        message.warning('Roller venue could not be saved')
        break
      }

      case getType(actions.deleteRollerData.request): {
        draft.integrations.roller.isLoading = true

        break
      }
      case getType(actions.deleteRollerData.success): {
        if (action.payload.serial in draft.integrations.roller.venues) {
          delete draft.integrations.roller.venues[action.payload.serial]
        }
        toast.success('Roller venue deleted')
        draft.integrations.roller.isLoading = false
        break
      }
      case getType(actions.deleteRollerData.failure): {
        draft.integrations.roller.isLoading = false
        break
      }
    }
  })

const diffCalc = (
  totals: StateType['reports']['comparison'],
  key: OrgRegKeys
) => {
  return {
    positive: totals.now.totals[key] > totals.previous.totals[key],
    value: relDiff(totals.now.totals[key], totals.previous.totals[key]),
  }
}

export default organisationsReducer
